//import React from 'react';
import React, { useEffect } from "react";
import { Routes, Route, Navigate } from 'react-router-dom';

import TransitionComponent from '../components/Transition';
import Home from '../views/Home';
import Services from '../views/Services';
import Portfolio from '../views/Portfolio';
import PortfolioDetails from '../views/PortfolioDetails';
import Profile from '../views/Profile';
import Contact from '../views/Contact';
import Archive from '../views/Archive';
import Featured_1 from '../views/PortfolioDetails';

const Router = () => {
 
 
  return (
    <Routes>
      <Route
        index
        element={
          <TransitionComponent>
            <Home />
          </TransitionComponent>
        }
      />
      <Route
        path="/portfolio"
        element={
          <TransitionComponent>
            <Portfolio />
          </TransitionComponent>
        }
      />

      <Route
        path="/portfolio/:design_slug"
        element={
          <TransitionComponent>
            <PortfolioDetails />
          </TransitionComponent>
        }
      />
      
      <Route
        path="/services"
        element={
          <TransitionComponent>
            <Services />
          </TransitionComponent>
        }
      />
      <Route
        path="/profile"
        element={
          <TransitionComponent>
            <Profile />
          </TransitionComponent>
        }
      />
      <Route
        path="/contact"
        element={
          <TransitionComponent>
            <Contact  /> 
          </TransitionComponent>
        }
      />
       <Route
        path="/archive"
        element={
          <TransitionComponent>
            <Archive  />
          </TransitionComponent>
        }
      />
       <Route
        path="/portfolio"
        element={
          <TransitionComponent>
            <Featured_1 />
          </TransitionComponent>
        }
      />
      
   {/* Catch-all Route: Redirects any unknown URL back to Home */}
   <Route path="*" element={<Navigate to="/" replace />} />

    </Routes>
  );
};

export default Router;
